import { Link, useLocation } from 'react-router-dom'
import { Sparkles, ChevronRight } from 'lucide-react'
import { useAuthStore } from '../store/authStore'

const pages: Record<string, string> = {
  '/pricing': 'Тарифы',
  '/ai-models': 'Модели',
  '/faq': 'FAQ',
  '/terms': 'Условия',
  '/privacy': 'Конфиденциальность',
  '/support': 'Поддержка',
}

export default function PublicLayout({ children }: { children: React.ReactNode }) {
  const { user } = useAuthStore()
  const location = useLocation()
  const segments = location.pathname.split('/').filter(Boolean)
  const currentPage = pages[location.pathname] || segments[0]?.charAt(0).toUpperCase() + segments[0]?.slice(1) || ''

  return (
    <div className="min-h-screen bg-[#0f0f1a] flex flex-col">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 border-b border-white/5 bg-[#0f0f1a]/80 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-4">
          {/* Первая строка: лого + кнопки */}
          <div className="h-16 flex items-center relative">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap flex-shrink-0">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center flex-shrink-0">
                <Sparkles className="w-4 h-4 text-white" />
              </div>
              <span className="text-xl font-bold gradient-text">Chat-Neuro</span>
            </Link>
            <nav className="hidden sm:flex items-center gap-2 absolute left-1/2 -translate-x-1/2">
              <Link to="/pricing" className="px-3 py-2 text-base text-white/80 hover:text-white transition-colors">Тарифы</Link>
              <Link to="/ai-models" className="px-3 py-2 text-base text-white/80 hover:text-white transition-colors">Модели</Link>
            </nav>
            <div className="flex items-center gap-2 ml-auto relative">
              {user ? (
                <Link to="/chat" className="gradient-btn px-5 py-2 rounded-xl text-sm inline-flex items-center gap-2 whitespace-nowrap">
                  <Sparkles className="w-3.5 h-3.5" />
                  {user.name || 'Мой аккаунт'}
                </Link>
              ) : (
                <>
                  <Link to="/login" className="px-4 py-2 text-base text-white/80 hover:text-white transition-colors whitespace-nowrap">Войти</Link>
                  <Link to="/register" className="gradient-btn px-5 py-2 rounded-xl text-sm whitespace-nowrap">Регистрация</Link>
                </>
              )}
            </div>
          </div>
          {/* Вторая строка: Тарифы / Модели на мобилке */}
          <div className="flex sm:hidden items-center justify-center gap-2 pb-2">
            <Link to="/pricing" className="px-3 py-1.5 text-sm text-white/80 hover:text-white transition-colors">Тарифы</Link>
            <Link to="/ai-models" className="px-3 py-1.5 text-sm text-white/80 hover:text-white transition-colors">Модели</Link>
          </div>
        </div>
      </header>

      {/* Breadcrumbs */}
      <div className="max-w-6xl mx-auto w-full px-4 pt-20 pb-2">
        <nav className="flex items-center gap-1.5 text-sm text-gray-500" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-gray-300 transition-colors text-xs">Главная</Link>
          {segments.length > 0 && (
            <>
              <ChevronRight className="w-3 h-3 text-gray-600" />
              <span className="text-gray-300 text-xs">{currentPage}</span>
            </>
          )}
        </nav>
      </div>

      {/* Content */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer */}
      <footer className="border-t border-white/5 py-12 px-6">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Sparkles className="w-5 h-5 text-indigo-400" />
            <span className="text-xl font-semibold gradient-text">Chat-Neuro.ru</span>
          </div>
          <div className="flex items-center justify-center flex-wrap gap-x-4 gap-y-0.5 text-base text-white/80 max-w-full">
            <span className="whitespace-nowrap">© 2026 Chat-Neuro</span>
            <Link to="/pricing" className="hover:text-gray-300 transition-colors whitespace-nowrap">Тарифы</Link>
            <Link to="/ai-models" className="hover:text-gray-300 transition-colors whitespace-nowrap">Модели</Link>
            <Link to="/faq" className="hover:text-gray-300 transition-colors whitespace-nowrap">FAQ</Link>
            <Link to="/terms" className="hover:text-gray-300 transition-colors whitespace-nowrap">Условия</Link>
            <Link to="/privacy" className="hover:text-gray-300 transition-colors whitespace-nowrap">Конфиденциальность</Link>
            <Link to="/support" className="hover:text-gray-300 transition-colors whitespace-nowrap">Поддержка</Link>
          </div>
        </div>
      </footer>
    </div>
  )
}
